import { createLogic } from 'redux-logic';

import {
  searchCustomersFulfilled,
  searchCustomersRejected,
} from 'store/searchCustomers/actions';
import {
  SEARCH_CUSTOMERS,
  SearchCustomersAction,
} from 'store/searchCustomers/types';
import { AppState } from 'store/store';
import { findMember } from 'lava/api';

export const searchCustomersLogic = createLogic({
  type: SEARCH_CUSTOMERS,
  latest: true,

  async process(
    {
      action,
      getState,
    }: { action: SearchCustomersAction; getState: () => object },
    dispatch,
    done
  ) {
    const searchValue = action.payload;

    let memberID = '';

    // email regex from W3C https://www.w3.org/TR/html-markup/input.email.html#input.email.attrs.value.multiple
    if (/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(searchValue)) {
      memberID = searchValue.toLowerCase();
    } else {
      dispatch(
          searchCustomersRejected({
            validationError: new Error('Please enter a valid email.'),
          })
      );
      done();
      return;
    }

    const posContext = (getState() as AppState).context.posContext;

    try {
      const customers = await findMember(posContext, memberID);

      dispatch(searchCustomersFulfilled(customers));
    } catch (error) {
      dispatch(searchCustomersRejected({ apiError: error as Error }));
    } finally {
      done();
    }
  },
});
